import { Component, OnInit, Input } from '@angular/core';
import { CockpitService } from '../../../service/cockpit/cockpit.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

@Component({
  selector: 'app-bulk-renewal-proposal',
  templateUrl: './bulk-renewal-proposal.component.html',
  styleUrls: ['./bulk-renewal-proposal.scss']
})
export class BulkRenewalProposalComponent implements OnInit {

  @Input('follow') follow: boolean;

  public bulkRewalProposal: Array<any> = new Array<any>();
  public orderby: string = "CodigoProposta";
  public sort: string = "asc";

  constructor(private CockpitService: CockpitService,
    private router: Router,
    private route: ActivatedRoute,
    private flashMessagesService: FlashMessagesService) {
  }

  ngOnInit() {
    this.getBulkRewalProposal();
  }

  setOrder(orderby) {
    if (this.orderby != orderby) {
      this.sort = "asc";
    } else {
      this.sort = this.sort == "asc" ? "desc" : "asc";
    }
    this.orderby = this.orderby != orderby ? orderby : this.orderby;
    this.getBulkRewalProposal();
  }

  getBulkRewalProposal() {
    this.CockpitService.getBulkRewal(this.follow, this.orderby, this.sort).subscribe(result => {
      if (result.Success) {
        console.log(result.Success);
        this.bulkRewalProposal = result.Result;
        console.log(result.bulkRewalProposal);
      } else {
        this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
      }
    }, error => {
      console.log(error);
    });
  }

  openProposal(id) {   
    this.router.navigateByUrl('/renovacao-vigencia/' + id);
  }

}



// WEBPACK FOOTER //
// ./src/app/cockpit/component/cockpit/bulk-renewal-proposal/bulk-renewal-proposal.component.ts